import * as React from "react";
import styled from "@emotion/styled";
import { AddToCartButton } from "@shopify/hydrogen-react";
import type { AddToCartButtonProps } from "@shopify/hydrogen-react/dist/types/AddToCartButton";
import { Button } from "atoms";
import { trackEvent } from "contexts/mixpanel";

type AddToCartProps = Omit<AddToCartButtonProps, "children" | "quantity"> & {
  quantity?: number;
};

const trackAddToCart = (variantId: string | null | undefined) =>
  trackEvent({ name: "AddToCartShopify", variantId });

function AddToCart({
  quantity = 1,
  variantId,
  onClick = noop,
  ...props
}: AddToCartProps) {
  const handleOnClick = (event?: React.MouseEvent<HTMLButtonElement>) => {
    // Allow parent's onClick to prevent the event
    if (onClick(event) !== false) {
      trackAddToCart(variantId);
    }
  };

  return (
    <AddToCartButton
      as={SButton}
      disabled={!variantId}
      {...props}
      onClick={handleOnClick}
      quantity={quantity}
      variantId={variantId}
    >
      Add to Cart
    </AddToCartButton>
  );
}

const SButton = styled(Button)({
  paddingBlock: 12,
  fontSize: 18,
});

export { AddToCart };
